const initialState = {
    ignoredWebAgent: false,
    ignoredAssetUpdate: false,
    ignoredFirmwareUpdate: false,
    ignoredFirmwareKey: null,
}

const userIgnoredUpdatesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'USER_IGNORED_WEB_AGENT':
            return {
                ...state,
                ignoredWebAgent: true,
            }

        case 'USER_IGNORED_ASSET_UPDATE':
            return {
                ...state,
                ignoredAssetUpdate: true,
            }

        case 'USER_IGNORED_FIRMWARE_UPDATE':
            return {
                ...state,
                ignoredFirmwareUpdate: true,
                ignoredFirmwareKey: action.payload || null,
            }

        case 'CLEAR_IGNORED_FLAGS':
            return {
                ...state,
                ignoredWebAgent: false,
                ignoredAssetUpdate: false,
                ignoredFirmwareUpdate: false,
                ignoredFirmwareKey: null,
            }

        case 'CLEAR_IGNORED_FIRMWARE':
            return {
                ...state,
                ignoredFirmwareUpdate: false,
                ignoredFirmwareKey: null,
            }

        default:
            return state
    }
}

export default userIgnoredUpdatesReducer
